// cute rain by Danielle

function cuteRain() {
  
    if (!image_urls) {
        var image_urls = Array()
    }
    if (!flash_urls) {
        var flash_urls = Array()
    }
        image_urls['rain1'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/watermelon_icon_c1e6579d-d6f3-4426-bb23-ff4f1f349c1d.png?18153517919393467930";
        image_urls['rain2'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/strawberry_icon_8fdce432-22c5-4ac9-822f-6d562489c5b7.png?12272122084011894187";
        image_urls['rain3'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/popsicle_icon_e9a18b08-973a-4c41-9973-55a89bd93005.png?12272122084011894187";
        image_urls['rain4'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/lips_iconf.png?12272122084011894187";
        image_urls['rain5'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/ice_cream_cone_pink_yellow_icon_04c79b2b-abdd-45f3-bc43-96d739bcf37b.png?12272122084011894187";
        image_urls['rain6'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/heart_blue_icon_95bfd1c0-0ea9-4b76-a16c-b4cff6420478.png?12272122084011894187";
        image_urls['rain7'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/doughnut_pink_icon_d9ffd0e1-6317-4e13-82ec-1fd0c499afa0.png?12272122084011894187";
        image_urls['rain8'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/cupcake_icon_56b82208-2a25-4df5-8ef8-c9fda250adc3.png?12272122084011894187";
        image_urls['rain9'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/bear_pink_icon_ea0a900e-9ca3-4dd1-86c2-61cc457131da.png?12272122084011894187";
        image_urls['rain10'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/tiara.png?3577368445156501197";
        image_urls['rain11'] = "https://cdn.shopify.com/s/files/1/1029/7877/files/Layer_15.png?3577368445156501197"; // pink donut
        image_urls['rain12']="https://cdn.shopify.com/s/files/1/1029/7877/files/heart_pink_icon_2.png?12272122084011894187";
    
  
  $(document).ready(function() {
        var flipped = 0;
        var iconClass;
        var counter = 0;
        var c = $(window).width();
        var d = $(window).height() + 200;
        var e = function(a, b) {
            return Math.round(a + (Math.random() * (b - a)))
        };
        var f = function(a) {
           if (counter == 35) {
                // stop after 35 icons
                return;
            }
            counter += 1;
            setTimeout(function() {
                a.css({
                    left: e(0, c) + 'px',
                    top: '-30px',
                    display: 'block',
                    opacity: '0.' + e(10, 100)
                }).animate({
                    top: (d - 10) + 'px'
                }, e(7500, 8000), function() {
                    $(this).fadeOut('slow', function() {
                        f(a)
                    })
                })
            }, e(1, 8000))
        };
        $('<div></div>').attr('id', 'rainDiv')
            .css({
                position: 'fixed',
                width: (c - 20) + 'px',
                height: '1px',
                left: '0px',
                top: '-5px',
                'z-index': '100',
                display: 'block'
            }).appendTo('body');
        for (var i = 1; i <= 30; i++) { // how many icons to release at a time
             // var g = $('<img/>').attr('src', "{{ 'logo.png' | asset_url }}") // use liquid variable
            
             flipped = e(0,1);
             if (flipped == 0) 
               iconClass = "<img/>";
             if (flipped == 1)
               iconClass = "<img class=\"flipRain\"/>";
          
             var g = $(iconClass).attr('src', image_urls['rain' + e(1, 12)]) // use 12 icons
                 .css({
                    position: 'absolute',
                    left: e(0, c) + 'px',
                    top: '-90px',
                    display: 'block',
                    'class': 'flipRain',
                    width: e(25, 32) + 'px', // random icon sizes
                    opacity: '0.' + e(10, 100),
                    'margin-left': 0
                }).addClass('rainDrop').appendTo('#rainDiv');
            f(g);
            g = null
        };
        var h = 0;
        var j = 0;
        $(window).resize(function() {
            c = $(window).width();
            d = $(window).height()
        })
    });
}